import { render, staticRenderFns } from "./premium-data.vue?vue&type=template&id=4e523aa8&scoped=true&"
import script from "./premium-data.vue?vue&type=script&lang=js&"
export * from "./premium-data.vue?vue&type=script&lang=js&"
import style0 from "./premium-data.vue?vue&type=style&index=0&id=4e523aa8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e523aa8",
  null
  
)

export default component.exports